import { FloatingFormItem, Group } from '@/components/_common';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Checkbox, Col, Form, Input, Row, Tooltip, Typography } from 'antd';
import InvoiceSerieNumberFields from '../fields/InvoiceSerieNumberFields';
import InvoiceTributesDefaultFields from '../fields/InvoiceTributesDefaultFields';
import StateCsrtSelect from '../fields/StateCsrtSelect';
import { CompanyInvoiceSettingsForm } from '@/core/domain/invoice/settings/Settings.types';
import { FormInstance } from 'antd/es/form/Form';
import { useCompanyFormContext } from '../../CompaniesFormProvider';
import { Info } from 'react-feather';

interface Props {
  configNfc?: number;
  form: FormInstance<CompanyInvoiceSettingsForm>;
}

const CompanyInvoiceNFc: React.FC<Props> = ({ configNfc, form }: Props) => {
  const { useInternalInvoiceApiNfc, company } = useCompanyFormContext();
  const companyState = company?.companyAddress?.state;

  const ruleRequired = useDefaultEmptyFieldError();

  return (
    <>
      <Form.Item name={['nfc', 'id']} hidden>
        <Input />
      </Form.Item>

      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Typography.Title level={4}>Geral</Typography.Title>

          <Row gutter={[16, 16]}>
            {!useInternalInvoiceApiNfc && (
              <Col>
                <Form.Item
                  name={['nfc', 'automaticIbptCalculation']}
                  valuePropName="checked"
                >
                  <Checkbox>Cálcular IBPT automático</Checkbox>
                </Form.Item>
              </Col>
            )}

            <Col>
              <Form.Item
                name={['nfc', 'emailDelivery']}
                valuePropName="checked"
              >
                <Checkbox>E-mail de entrega</Checkbox>
              </Form.Item>
            </Col>

            <Col span={24} md={12}>
              <FloatingFormItem
                label="Natureza da operação"
                name={['nfc', 'natureOfOperationDefault']}
              >
                <Input />
              </FloatingFormItem>
            </Col>

            <Col span={24} md={12}>
              <Form.Item
                name={['nfc', 'shouldNotDeductExemptIcmsDefault']}
                initialValue={false}
                valuePropName="checked"
              >
                <Checkbox>
                  ICMS desonerado não diminui no total da nota
                </Checkbox>
              </Form.Item>
            </Col>

            <Col span={24} md={12}>
              <Group>
                <Form.Item
                  name={['nfc', 'useQrCodeVersion3']}
                  valuePropName="checked"
                  noStyle
                >
                  <Checkbox>Utilizar QR Code NFC-e versão 3.00</Checkbox>
                </Form.Item>

                <Tooltip title="Ativado: utiliza QR Code na versão 3.00. Desativado: utiliza QR Code na versão 2.00.">
                  <Info size={20} id="note-type-icon" cursor="pointer" />
                </Tooltip>
              </Group>
            </Col>

            <Col span={24} md={12}>
              <FloatingFormItem
                label="Identificador do Código de Segurança do Responsável Técnico (CSRT)"
                name={['nfc', 'stateCsrtId']}
              >
                <StateCsrtSelect state={companyState} />
              </FloatingFormItem>
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <Typography.Title level={4}>Tributos</Typography.Title>

          <InvoiceTributesDefaultFields invoiceType={'nfc'} form={form} />
        </Col>

        <Col span={24}>
          <Typography.Title level={4}>Série e Numeração</Typography.Title>

          <Row gutter={[16, 16]}>
            <Col span={24}>
              <InvoiceSerieNumberFields configNfc={configNfc} />
            </Col>

            <Col span={24} md={12} lg={6}>
              <FloatingFormItem
                rules={[ruleRequired]}
                label="Código de segurança NFCe"
                name={['nfc', 'securityCodeNfce']}
              >
                <Input />
              </FloatingFormItem>
            </Col>

            <Col span={24} md={12} lg={6}>
              <FloatingFormItem
                rules={[ruleRequired]}
                label="Token CLD"
                name={['nfc', 'cldToken']}
              >
                <Input />
              </FloatingFormItem>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default CompanyInvoiceNFc;
